import { createSelector } from '@reduxjs/toolkit';
import { IAppState } from 'store/store';

const getStateSelector = (state: IAppState) => state.entities.signup;

export const signupSelectors = {
  get: createSelector(getStateSelector, state => state),
};
